import { Environment, RecordSource, Store, fetchQuery } from 'relay-runtime';
import { createNetworkLayer } from '@stackworx/relay';

import { serverUrl } from '../service';

import reduxStore from '../store';

const source = new RecordSource();
const store = new Store(source);
const handlerProvider = null;

/**
 * Used so that we can dynamically switch out the store,
 * e.g. on logout so that there is no stale data left
 */

export default class RelayStore {
  static relayStore = null;

  static init() {
    this.reduxStore = reduxStore;
    this.network = createNetworkLayer({
      endpointUrl: `${serverUrl}/graphql`,
      enableNetworkLogger: true,
      onRequestStarted: () => {},
      onRequestCompleted: () => {},
      onRequestError: () => {},
      onRequestUnauthorized: () => {
        // TODO logout
      },
      isAuthenticated: () => {
        const { auth } = reduxStore.getState();
        return auth && auth.authenticated;
      },
      getAuthToken: () => {
        const { auth } = reduxStore.getState();
        return auth && auth.token;
      },
      authTokenHeaderName: 'Authentication-Token',
    });
    this.reset();
  }

  static fetchQuery(query: string, variables: any = {}) {
    // TODO cache config
    return fetchQuery(RelayStore.store, query, variables, {});
  }

  static reset() {
    this.relayStore = new Environment({
      handlerProvider,
      network: this.network,
      store,
    });
  }

  static get store() {
    return this.relayStore;
  }
}

RelayStore.init();



// WEBPACK FOOTER //
// ./src/relay/RelayStore.js